import { Spinner, SpinnerSize } from "@next-platform/client-common-spicy-ui";

export const LoadingPlaceholder = () => {
  return (
    <div className="flex items-center justify-center rounded-md bg-gray-7 min-w-[154px] w-[154px] h-[200px] md:w-[240px] md:h-[312px] outline outline-2 outline-blue-500 mt-2 ml-2">
      <Spinner size={SpinnerSize.LARGE} />
    </div>
  );
};
